export const websitePhoneNumber = {
    raw: '+441417745023',
    display: '0141 774 5023',
};

export const websiteEmailAddress = 'support@simpleonlinepharmacy.co.uk';
